import { useRef, useState } from 'react'
import Map, { MapRef, Marker, Popup } from 'react-map-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { Devices } from '../models/devices'
import { Stack } from '@mantine/core'

type Props = {
  devices: Devices[]
}

export default function MapContainer({ devices }: Props) {
  const mapRef = useRef<MapRef>(null)
  const [selectedDevice, setSelectedDevice] = useState<Devices | null>(null)

  return (
    <div style={{ width: '100%', height: '100%', padding: '0 75px 20px 75px' }}>
      <Map
        ref={mapRef}
        mapboxAccessToken="pk.eyJ1IjoiaGJhbmRvdiIsImEiOiJjbHVoMTZqazEya2p5MnNsMHF1c3ZicmV6In0.wcM_OYGTxxDZq8D8tnfKxA"
        initialViewState={{
          latitude: 44.8146563,
          longitude: 15.86896,
          zoom: 1,
        }}
        style={{ width: '100%', height: '100%' }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        attributionControl={false}
        onClick={() => setSelectedDevice(null)} // Close popup on map click
      >
        {devices.map((device) => {
          if (device.last_known_location) {
            return (
              <Marker
                key={device.imei}
                longitude={device.last_known_location.coordinates[0]}
                latitude={device.last_known_location.coordinates[1]}
                anchor="bottom"
                onClick={(e) => {
                  e.originalEvent.stopPropagation()
                  setSelectedDevice(device)
                }}
                style={{ cursor: 'pointer' }}
              />
            )
          }
        })}

        {selectedDevice && selectedDevice.last_known_location && (
          <Popup
            longitude={selectedDevice.last_known_location.coordinates[0]}
            latitude={selectedDevice.last_known_location.coordinates[1]}
            anchor="bottom"
            offset={60}
            onClose={() => setSelectedDevice(null)}
          >
            <Stack p={10}>
              {`${selectedDevice.name} (${selectedDevice.imei})`}
            </Stack>
          </Popup>
        )}
      </Map>
    </div>
  )
}
